var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "roles" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c("Search", {
            attrs: {
              model: _vm.search,
              elem: _vm.searchElem,
              "btn-loading": _vm.list.loading,
            },
            on: { "on-search": _vm.handleDataList },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "extra" }, slot: "extra" },
        [
          _c(
            "Button",
            {
              attrs: { icon: "md-add", type: "primary" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v("添加")]
          ),
        ],
        1
      ),
      _c("Table", {
        ref: "list",
        attrs: {
          stripe: "",
          columns: _vm.columns,
          data: _vm.list.data,
          "highlight-row": "",
          "row-class-name": _vm.tableRowClassName,
        },
        on: { "on-selection-change": _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "operation",
            fn: function ({ row }) {
              return [
                _vm.userType <= 3
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleUser(row)
                          },
                        },
                      },
                      [_vm._v("用户")]
                    )
                  : _vm._e(),
                _vm._v("  \n        "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "ivu-icon ivu-icon-md-create",
                      staticStyle: {
                        "font-size": "16px",
                        "margin-top": "-2px",
                        "margin-right": "2px",
                      },
                    }),
                    _vm._v("编辑"),
                  ]
                ),
                _vm._v("  \n        "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleRemove(row)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "ivu-icon ivu-icon-md-trash",
                      staticStyle: {
                        "font-size": "16px",
                        "margin-top": "-2px",
                        "margin-right": "2px",
                      },
                    }),
                    _vm._v("删除"),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("Page", {
        staticClass: "page",
        staticStyle: { "margin-top": "10px" },
        attrs: {
          placement: "top",
          "show-total": "",
          "show-elevator": "",
          "show-sizer": "",
          total: _vm.list.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "page-size-opts": [10, 20, 50, 100, 200],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c("RoleEdit", { ref: "edit", on: { "on-update": _vm.handleDataList } }),
      _c(
        "Modal",
        {
          attrs: { width: "60%", title: _vm.windowTitle },
          model: {
            value: _vm.userWindow,
            callback: function ($$v) {
              _vm.userWindow = $$v
            },
            expression: "userWindow",
          },
        },
        [
          _c("usersManage", { ref: "user" }),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }